export const ProductModuleTranslations: Array<string> = [
    // title
    'xmlProducts',
    'xmlAttributes',
    'xmlFavoritesPermission',

    'Admin.QPEdit.Permissions',
    'Admin.QPEdit.Permissions.Edit',
    // Add-edit product
    'Admin.Products.DoesntExist',

    // product defn
    'Admin.PSW.Step1.SimpleProduct',
    'Admin.PSW.Step1.ConfigurableProduct',
    'Admin.PSW.Step1.CollectionOfConfigurableProducts',
    'Admin.PSW.Step1.ConfigurableSystemList',
    'Admin.PSW.Step1.ParentChildSystem',
    'Admin.Product.DisplayedTypeRequired',
    'Admin.Product.DisplayTypes',
    'Admin.PSW.Step1.ConfigurationType',
    'Admin.PSW.Step1.ConfigurationTypeInfo',
    'Admin.PSW.Step1.ConfigurationTypeInfo.NewQuote.StandardProduct',
    'Admin.PSW.Step1.ConfigurationTypeInfo.NewQuote.VCProduct',
    'Admin.Product.ProductTypeRequired',
    'Admin.Product.AddNewProductType',
    'Admin.Controls.Properties.DynamicDescription',
    'Admin.AddEditUserType.LabelStartCategory',
    'Admin.ProductVersion',
    'Admin.SalesUnitsOfMeasure',
    'Admin.PSW.Step1.PricingMechanism',
    'xsltBasePrice',
    'Admin.PSW.Step7.PriceFormula',
    'Admin.PSW.Step1.Cost',
    'ProductExportImport.RecurringPricePeriod',
    'ProductExportImport.RecurringPriceFormula',
    'Admin.PSW.Step1.ProductVisibilityPermissions',
    'Admin.PSW.Step1.StartDate',
    'Admin.PSW.Step1.EndDate',
    'ProductExportImport.ExternalID',
    'ProductImport.UPC',
    'ProductImport.MPN',
    'ProductExportImport.Inventory',
    'ProductExportImport.LeadTime',
    'Admin.PSW.Step1.FamilyCode',
    'Admin.PSW.Step1.ProductWeightIn',
    'Admin.PSW.Step1.WeightHint',
    'Admin.PSW.Step1.ProductDescriptionLong',
    'Admin.PSW.Step1.ImageLarge',
    'PSW.ExecuteRulesOnce',
    'PSW.AllowProductConfigurationImport',
    'PSW.AlwaysAllowRenewal',
    'PSW.UpdateAsset',
    'Admin.modifyitemattributes.LabelCanEnterQty',
    'Admin.SkipLoadRelatedProducts',
    'Admin.PSW.LineItemInfo.Value1',
    'Admin.PSW.LineItemInfo.Value2',
    'Admin.PSW.LineItemInfo.Value3',
    'Admin.PSW.Step1.PricingCode',
    'ProductExportImport.RecurringCostFormula',
    'ProductExportImport.RecurringCostPeriod',
    'Admin.PSW.Step1.BaseRecurringPrice',
    'Admin.PSW.Step1.RankWithinCategory',
    'Admin.CategoryML.Title',
    'Admin.ImportExport.SelectCategories',
    'Admin.Deployment.CreatedBy',
    'ProductList.ModifiedBy',
    'Admin.ProductDefinition.PermissionsAndEffectivityDates',
    'CategoryModifications.VisibilityOfProductsInfoMessage',
    'Admin.ProductDefinition.CantReplaceItself',
    'Admin.ProductDefinition.AdditionalProductData',
    'Admin.PSW.Step1.ShippingCosts',
    'PSW.UploadConfigurationTemplate',
    'Admin.AddEditScript.Script',
    'Develop.CustomsSripts.F11',
    'Admin.ProductAdministration.ProductEndOfLifeStatus',
    'Admin.ProductAdministration.Discontinued',
    'Admin.ProductAdministration.ReplacedBy',
    'Admin.Msg.CheckIfProductIsInUse',
    'Admin.Pricebook.PartNumberNotDefined',
    'Product.Administration.PleaseSelectReplacementProduct',
    'ProductExportImport.UnitOfMeasure',
    'ProductExportImport.GeneralItemCategoryGroup',
    'Admin.HasUsagePricing',
    'Admin.SubscriptionItemCategoryType',
    'Admin.IsBundleProduct',
    'Admin.AddEditUserType.LabelDescription',
    'Admin.UpgradeAliasesToNewVersionMsg',
    'Admin.Categories.AltText',
    'Admin.PSW.ConfigurationTypeAndPricingType.ConfigurationType',
    'Admin.PSW.ConfigurationTypeAndPricingType.Standard',
    'Admin.PSW.ConfigurationTypeAndPricingType.PricingType',
    'Admin.PSW.ConfigurationTypeAndPricingType.VariantPricing',
    'Admin.PSW.ConfigurationTypeAndPricingType.CanNotBeSelected',
    'Admin.Products.CollectionDisplayTypeUnsupported',

    'Admin.AddEditAttributeContainerContent.AddNewProduct',
    'Admin.Msg.CancelButton',
    'Admin.Msg.Save',
    'Admin.Msg.Yes',
    'Admin.QuotePropertyEdit.Definition',
    'Admin.Controls.AttributeList.Attributes',
    'Admin.RulesAndMessages',
    'Admin.Scripts.Title',
    'Admin.Layout',
    'Admin.AdvancedSettings',
    'Admin.ProductDefinition.Pricing',
    'ProductList.DateModified',
    'Admin.ProductTypeML.Title',
    'Admin.PSW.AddValuesFromProductList',
    'Admin.PSW.Step1.ModifiedBy',
    'Admin.PSW.Step1.CreatedBy',
    'Admin.PSW.Step1.VersionNumber',
    'Admin.Attribute.AddLineItem',
    'Admin.PSW4.InheritQuantityFromParent',
    'ProductList.ChooseCategories',
    'Admin.PSW.Step1.PricingFormula',
    'Admin.PSW.AddTrigger',
    'Admin.PSW.Step1.ProductDescriptionHint',
    'Admin.PSW.Step1.ProductTypeHint',
    'Admin.PSW.Step1.ProductCategoryHint',
    'Admin.PSW.Step1.PricingCodeMsg',
    'Admin.PSW.Step7.CostMsg',
    'Admin.PSW.Step7.PriceFormulaMsg',
    'Admin.PSW.Step7.RecurringPricePeriodMsg',
    'Admin.PSW.Step7.RecurringCostPeriodMsg',
    'Admin.PSW.Step1.ProductWillBecomeAvailableAfterThisDate',
    'Admin.PSW.Step1.ProductWillBeAvailableBeforeThisDate',
    'PSW.AllowProductConfigurationImportHint',
    'PSW.ExecuteRulesOnceHint',
    'PSW.UpdateAssetHint',
    'PSW.AlwaysAllowRenewalHint',
    'Admin.PSW.Step7.DynDescMsg',
    'Admin.PSW.Step7.CanEnterQtyMsg',
    'Admin.PSW.Step1.SimpleProductHintForNewQuoteEngine',
    'Admin.PSW.Step1.SimpleProductHint',
    'Admin.PSW.Step1.ConfigurableProductHint',
    'Admin.PSW.Step1.CollectionOfConfigurableProductsHint',
    'Admin.PSW.Step1.ConfigurableSystemHint',
    'Admin.PSW.Step1.ParentChildSystemHint',
    'Admin.PSW.Step1.SystemIdHint',
    'Admin.Product.SubscriptionProduct',
    'Admin.Common.Version',
    'Product.OrderItemType.Sales',
    'Product.OrderItemType.Subscription',
    'Product.OrderItemType.SubscriptionBilling',
    'Product.OrderItemType.ServiceContract',
    'Product.OrderItemType',
    'Product.OrderItemType.Hint',
    'Product.AutoRenewalIndicator',
    'Admin.ProductDefinition.ApplyCategoryPermissions',
    'Product.PricebookLookupPricingTypeWarning',
    'Product.PricebookLookupPricingTypeAliasWarning',

    // Products grid
    'Admin.Products.CancelDeleteWarning',
    'Admin.Products.DeleteWarning',
    'ProductList.ImportNew',
    'ProductList.ImportTranslationNew',
    'Admin.ProductVersion',
    'ProductList.SyncedWithSAP',
    'ProductList.ActiveVersion',
    'Admin.Products.SuccessfullyDeleted',
    'ProductList.AliasOf',
    'xsltDateModifiedFrom',
    'xsltDateModifiedTo',
    'ProductList.Import',
    'ProductList.Export',
    'ProductList.ExportProducts',
    'ProductList.ExportProductsAndRefine',
    'ProductList.ExportProductsTranslations',
    'ProductList.ExportProductsTranslationsAndRefine',
    'ProductList.ExportAllProductsWithFilters',
    'ProductList.ExportAllProductsWithoutFilters',
    'ProductList.EmailMeWhenDone',
    'ProductList.ExportAllProductTranslationsWithoutFilters',
    'ProductList.ExportAllProductTranslationsWithFilters',
    'ProductList.BulkProductImportExportRestricted',
    'ProductList.BulkProductTranslationImportExportRestricted',
    'Admin.add_edit_ut.LabelSelect',
    'Admin.Products.CrossPlantMaterialStatus.Ok',
    'Admin.Products.CrossPlantMaterialStatus.Warning',
    'Admin.Products.CrossPlantMaterialStatus.Error',
    'Admin.Products.XDistributionChannelStatus.Ok',
    'Admin.Products.XDistributionChannelStatus.Warning',
    'Admin.Products.XDistributionChannelStatus.Error',
    'ProductIntegration.OldMaterialNumber',
    'ProductIntegration.Division',
    'ProductIntegration.XDistributionChainStatus',
    'ProductIntegration.XDistributionChainStatusValidFrom',
    'ProductIntegration.CrossPlantMaterialStatus',
    'ProductIntegration.CrossPlantMaterialStatusValidFrom',
    // Favorites Permissions
    'Admin.CreateFavoritesPermissions.PromptForNewProductVersion',
    'Admin.CreateFavoritesPermissions.AbleToDefineOnCompanylevel',
    'Admin.CreateFavoritesPermissions.PermissionsOnCompanyLevel',
    'Admin.CreateFavoritesPermissions.Everyone',
    'Admin.CreateFavoritesPermissions.AbleToDefineOnSystemlevel',
    'Admin.CreateFavoritesPermissions.PermissionsOnSystemLevel',
    'xmlUserGroups',

    //general
    'Admin.CancelDeleteWarning',

    // columns
    'Admin.PSW.Step1.Category',
    'Admin.PSW.DisplayType',

    'admin.PromotionAddEditItem.AddNewProduct',
    'Admin.ContainerColumnAddEdit.DisplayRank',
    'Admin.ContainerColumnAddEdit.CalculationRank',
    'Admin.ContainerColumn.ColumnsRanking',
    'CustomerFieldsPermissions.Editable',
    'Admin.QPEdit.ReadDashOnly',
    'Admin.QPEdit.Required',
    'Admin.QPEdit.Hidden',
    'Admin.UserCustomField.SameForAll',


    //Pricing
    'Admin.PSW.ExtendedRatePlan.Description',
    'Admin.PSW.ExtendedRatePlan.Currency',
    'Admin.PSW.ExtendedRatePlan.RatePlanId',
    'Admin.PSW.ExtendedRatePlan.BillingCycle',
    'Admin.PSW.ExtendedRatePlan.AddSnapshot',
    'Admin.PSW.SubscriptionParameters',
    'Admin.QuotePropertyEdit.Pricing',
    'Admin.PSW.Step1.ExtendedRatePlan',
    'Admin.PSW.Step1.RatePlanTemplates',
    'Admin.PSW.Step1.RatePlanTemplatesRequired',
    'Admin.PSW.Step1.EnterTheNumberOfMonths',
    'Admin.PSW.Step1.EnterTheNumberOfMonthsMinimumTerm',
    'Admin.PSW.Step1.Market',
    'Admin.PSW.Step1.PricingType',
    'Admin.Msg.Add',
    'Admin.PSW.Step1.Parameters',
    'Admin.PSW.ExtendedRatePlan.Code',
    'Admin.PSW.ExtendedRatePlan.Description',
    'Admin.PSW.ExtendedRatePlan.InitialValue',
    'Admin.PSW.ExtendedRatePlan.Charges',
    'Admin.PSW.ExtendedRatePlan.OneTimeCharge',
    'Admin.PSW.ExtendedRatePlan.Charges.Charge',
    'Admin.PSW.ExtendedRatePlan.Charges.RatePlanElement',
    'Admin.PSW.ExtendedRatePlan.Charges.Price',
    'Admin.PSW.ExtendedRatePlan.Charges.Show',
    'Admin.PSW.ExtendedRatePlan.Charges.IncludedQuantity',
    'Admin.PSW.ExtendedRatePlan.Charges.BlockSize',
    'Admin.PSW.ExtendedRatePlan.Charges.CustomAmountCode',
    'Admin.PSW.ExtendedRatePlan.Charges.PricePerUnit',
    'Admin.PSW.ExtendedRatePlan.Charges.Ratio',
    'Admin.PSW.ExtendedRatePlan.Charges.MinimumBlocks',
    'Admin.PSW.Step1.UpTo',
    'Admin.PSW.Step1.PricePerUnit',
    'Admin.PSW.Step1.PricePerBlock',
    'Admin.PSW.Step1.FixedPrice',
    'Admin.PSW.ExtendedRatePlan.Charges.Proratable',
    'Admin.PSW.ExtendedRatePlan.Charges.BilledInAdvance',
    'Admin.Msg.SelectRatePlanTemplate',
    'Admin.Title.SelectRatePlanTemplate',
    'Admin.Pricing.ContractTermLength',
    'Admin.Pricing.MinimumContractTermLength',
    'Admin.Pricing.Months',
    'Admin.SaveSBPricing.SaveErrorContractLength',
    'Admin.SaveSBPricing.SaveErrorContractLengthInteger',
    'Admin.PSW.Step1.Show',
    'Admin.PSW.Step1.OneTime',
    'Admin.PSW.Step1.RecurringPricing',
    'Admin.PSW.Step1.BlockPricing',
    'Admin.PSW.Step1.Percentage',
    'Admin.PSW.Step1.VolumePricing',
    'Admin.PSW.Step1.TieredPricing',
    'Admin.PSW.ExtendedRatePlan.ParameterEmptyMessage',
    'Admin.PSW.Step1.SelectMarketOption',
    'Admin.PSW.Step1.MarketRatePlanExists',
    'Admin.PSW.ExtendedRatePlan.RatePlan',
    'Admin.PSW.TemplateNumber',
    'PriceBookEntries.LabelValidFrom',
    'Admin.Pricebooks.Entries.ValidUntil',

    // AttributeInstance
    'Admin.PSW.DuplicatedAttributeNamesNotAllowed',
    'Admin.PSW4.ListAsLineItem',
    'Admin.PSW4.Required',
    'Admin.PSW4.DisplayAs',
    'PSW.AddAttrDefn',
    'Admin.PSW.SpansAcrossEntireRow',
    'PSW.CustomLabel',
    'Admin.PSW4.DisplayButtonText',
    'Admin.PSW4.DisplayHint',
    'PSW.ShowOneTimePrice',
    'Admin.PSW4.ShowRecurringPrice',
    'PSW.Width',
    'PSW.Height',
    'PSW.FormulaForCalcAttrQty',
    'Admin.PSW4.CustomRangeErrorText',
    'Admin.PSW4.ValidInputIsFrom',
    'Admin.PSW4.To',
    'Admin.PSW4.TransferToContainer',
    'PSW.ExecuteRulesOnChange',
    'PSW.RefreshUIConfiguratorOnChange',
    'Admin.PSW.Config',
    'PSW.AttachScriptToThisAttribute',
    'PSW.ManageAttrAbsPos',
    'Admin.PSW.Standard',
    'Admin.PSW.TriggerEngine',
    'Admin.PSW4.Position',
    'Admin.PSW4.Size',
    'Admin.PSW4.W',
    'Admin.PSW4.H',
    'Admin.PSW4.bgCol',
    'Admin.PSW.AbsUse',
    'Admin.PSW.SearchCriteria',
    'Admin.PSW.ABSOptional',
    'Admin.PSW.ABSDontUse',
    'Admin.PSW.ABSCategories',
    'PSW.AttrValues',
    'PSW.DisplayToUser',
    'Admin.PSW4.ValueCode',
    'Admin.PSW4.LineItemDescription',
    'Admin.PSW4.ValueDescription',
    'Admin.PSW4.ReferenceProduct',
    'PSW.DisplayValues',
    'Admin.PSW4.OnlySearchIn',
    'Admin.PSW4.ListAsLineItemWhenPriceIsZero',
    'Admin.PSW4.PartNumber',
    'PSW.Sort',
    'Admin.PSW4.DefaultQuantity',
    'Admin.PSW4.SaticPrice',
    'Admin.PSW4.Price',
    'Admin.PSW4.RecurringPrice',
    'Admin.PSW4.RecurringCost',
    'Admin.Step4.PriceCode',
    'Admin.Step4.UsePricebook',
    'Admin.PSW4.Preselected',
    'Admin.PSW4.ImageOn',
    'Admin.PSW4.ImageOnAltText',
    'Admin.PSW4.ImageOff',
    'Admin.PSW4.ImageOffAltText',
    'Admin.ProductAttributeValuesDataTable.QuickSearch',
    'Admin.ProductAttributeValuesDatatable.TotalValues',
    'PSW.AttachScriptToThisAttribute',
    'Admin.PSW.Config',
    'Admin.Msg.CheckIfAttributeValueIsInUse',
    'Admin.Msg.CheckIfAttributeIsInuse',
    'Admin.Msg.InUse',
    'Admin.Msg.CheckUsage',
    'Admin.Msg.Visible',
    'Admin.AddProductRefValue',
    'PSW.HideUnselectedValues',
    'PSW.ShowMoreColumns',
    'Admin.AddEditAttributeContainer.AddNewValueButton',
    'Admin.NewAttributeValues.LabelAttributeValuesTitle',
    'Admin.NewAttributeValues.LabelAttributeValuesCodeTitle',
    'Admin.NewAttributeValues.LabelAttributeValuesRankTitle',
    'Admin.NewAttributeValues.BtnAddMoreAttValuesText',
    'Admin.AttributeValues.AddNewAttributeValuesTitle',
    'Admin.PSW4.Resort',
    'PSW.AttributesMarkedAsLineItems',
    'xsltPSWInfo2',
    'Admin.PSW4.SameProductAsEditing',
    'PSW.InheritProdTypeFrom',
    'Admin.PSW.IncludeInKOContext',
    'PSW.ManageContainerEvents',
    'PSW.ManageContainerEvents.ScriptOnRowAdded',
    'PSW.ManageContainerEvents.ScriptOnRowCopied',
    'PSW.ManageContainerEvents.ScriptOnRowDeleted',
    'PSW.ManageContainerEvents.ScriptOnCellEdited',
    'Admin.PSW.AttributeColumns',
    'PSW.RequiredInfo',
    'PSW.DisplayToUserInfo',
    'PSW.ExecuteRulesOnChangeHint',
    'PSW.RefreshUIConfiguratorOnChangeHint',
    'PSW.AttachScriptToThisAttributeHint',
    'Admin.Pricebook.AttributeValuePartNumberNotDefined',
    'PSW.PropagateAttrChange',
    'Admin.PSW4.ContainerSettings',
    'PSW.AddNewAttribute',
    'PSW.SelectContainerAttrs',
    'PSW.PropagateAttrChangeHint',
    'Admin.ProductAttributes.HintProductType',
    'ProductAttributeValues.InfoMessage',
    'ProductSegregation.CategoryWarningMessage',
    'ProductSegregation.VisibilityPermissionsWarningMessage',

    // Containers
    'Admin.Controls.ContainerNavigation.Step2',
    'Admin.Controls.ContainerNavigation.Step3',
    'Admin.Controls.ContainerNavigation.Step4',
    'Admin.Controls.ContainerNavigation.Step5',
    'Admin.ContainerSettings',
    'jsQPEdit.AllDefaultUT',

    // Containers - General tab
    'Admin.AddEditAttributeContainerContent.UseProducts',
    'Admin.AddEditAttributeContainerContent.MaxContainerRows',
    'Admin.AddEditAttributeContainerContent.MinContainerRows',
    'Admin.AddEditAttributeContainerContent.EnablePaging',
    'Admin.AddEditAttributeContainerContent.IsProductSearch',
    'Admin.AddEditAttributeContainerContent.NumberOfRows',
    'Admin.AddEditAttributeContainerContent.ContainerUsageLable',
    'Admin.AddEditAttributeContainerContent.SearchByPartNumberMsg',
    'Admin.AddEditAttributeContainerContent.NewColumn',
    'Admin.AddEditAttributeContainerContent.YouNeedToAdd',
    'Admin.AddEditAttributeContainerContent.SelectProductPartNumber',
    'Admin.AddEditAttributeContainerContent.ContainerUsageNoProducts',
    'Admin.AddEditAttributeContainerContent.ContainerUsageProduct',
    'Admin.AddEditAttributeContainerContent.ContainerUsagePartNumber',
    'Admin.AddEditAttributeContainerContent.IsProductSearchMsg',
    'Admin.AddEditAttributeContainerContent.ColumnContainsProductAttributes',
    'Admin.AddEditAttributeContainerContent.MinRows',
    'Admin.AddEditAttributeContainerContent.MaxRows',
    'Admin.AttributeAdmin.Container.MinBiggerThanMax',
    'Admin.AttributeAdmin.Autocompolete.SourcedFromQuoteTableInfo',
    'Admin.AttributeAdmin.Brim.SystemAttributeInfo',
    'Admin.AddEditAttributeContainerContent.ViewProduct',
    'Admin.AttributeAdmin.ServiceContractProduct.SystemAttributeInfo',
    'Admin.AttributeAdmin.DuplicateAttributeNameWarning',

    // Containers - Columns tab
    'Admin.ContainerColumnAddEdit.HeaderLabel',
    'Admin.ContainerColumnAddEdit.FooterLabel',
    'Admin.ContainerColumns.QuickFilter',
    'Admin.PSW.ColumnsTotal',
    'Admin.ContainerColumns.AddColumn',
    'Admin.ContainerColumnAddEdit.ColumnType',
    'Admin.ContainerColumnAddEdit.DisplayType',
    'AttributeML.ContainerColumnFormula',
    'Admin.ContainerColumnAddEdit.AlwaysIncludeInKOContext',
    'Admin.ColumnDefinition',
    'Admin.ColumnPermissions',
    'Admin.ContainerColumnAddEdit.TotalType',
    'Admin.ContainerColumnAddEdit.TotalFormula',
    'Admin.ContainerColumnAddEdit.DecimalPlaces',
    'Admin.ContainerColumnAddEdit.DataType',
    'Admin.ContainerColumnAddEdit.DisplayRank',
    'Admin.ContainerColumnAddEdit.Width',
    'Admin.ContainerColumnAddEdit.Height',
    'Admin.ContainerColumnAddEdit.SaveColumn',
    'Admin.CustomTablesDefineNew.ColumnNamesUnique',
    'Admin.ContainerColumnAttributeValues.QuickSearch',

    // Containers - Properties tab
    'Admin.ContainerColumnAddEdit.CalculationFormula',
    'Admin.AddEditAttributesContainerProperty.DataType',
    'Admin.AddEditAttributesContainerProperty.CalculationRank',
    'Admin.AddEditAttributesContainerProperty.IncludeInJson',
    'Admin.AddEditAttributesContainerProperty.DecimalPlaces',
    'Admin.AddEditAttributesContainerProperty.SaveProperty',
    'Admin.AttributesContainerProperties.AddNewProperty',
    'Admin.AddEditAttributesContainerProperty.TotalProperties',

    // Containers - Actions tab
    'Admin.ContainerActions.GlobalActions',
    'Admin.ContainerActions.RowActions',
    'Admin.ContainerActionsAndRules.AddNewRow',
    'Admin.ContainerActionsAndRules.OpenNewConfig',
    'Admin.ContainerActionsAndRules.DeleteRow',
    'Admin.ContainerActionsAndRules.CopyRow',
    'Admin.ContainerActionsAndRules.AllowMultipleCopy',
    'Admin.ContainerActionsAndRules.ReorderRows',
    'Admin.ContainerActionsAndRules.EditRow',

    // Containers - Validation rules tab
    'Admin.AttributeContainerRule.ValidationFormula',
    'Admin.AttributeContainerRule.Message',
	'Admin.AttributeContainerRule.Name',
    'Admin.ContainerActionsAndRules.AddNewRule',
	'Admin.AddEditAttributesContainerProperty.TotalValidationRules',
	'Admin.Msg.SaveRule',

    // Attributes table
    'Admin.Attribute.TotalAttributes',
    'Admin.Attribute.Tabs',
    'Admin.Attribute.NumberOfValuesTo',
    'Admin.Attribute.NumberOfValuesFrom',
    'Admin.Attribute.IsLineItem',
    'Admin.Attribute.HasTrigger',
    'Admin.Attribute.AddNewProductAttribute',
    'Admin.Common.Name',
    'Admin.Attribute.NumberOfValues',
    'Admin.PSW.SaveAttribute',
    'PSW.ViewPrices',
    'Admin.PSW4.UserCanEnterQuantity',
    'xsltPSWInfo1',
    'Admin.PSW4.OrderWithinTheCart',
    'Admin.PSW.AttributeName',
    'Admin.PSW4.Cost',
    'Admin.Msg.CheckButton',
    'Admin.Attributes.QuickFilters',
    'Admin.AttributesDataTable.QuickSearch',
    'Admin.Attribute.TotalAttributes',
    'PSW.AddNewAttribute',
    'Admin.Attribute.IsRequired',
    'AttributeList.Name',
    'AttributeList.SystemID',
    'AttributeList.Type',
    'UserList.ModifiedByUserName',
    'xsltModifiedDateFrom',
    'xsltModifiedDateTo',
    'UserList.DateModified',
    'DocumentGenerationTemplates.UsedIn',
    'Admin.Attributes.BillingPeriod',
    'AttributeAdmin.ValueIsUsedByProducts',

    // Add-edit attributes
    'Admin.Attributes.AddNewAttribute',
    'xmlAttributes',
    'xsltCheckIfAttributeIsInUse',
    'Admin.add_edit_attribute.ChangingAttributeTypeWarning',
    'Admin.add_edit_attribute.DynamicAttTypeInfo',
    'Admin.add_edit_attribute.DynamicAttDisplayTypeInfo',
    'AttributeAdmin.Type.Dynamic',
    'Admin.Attribute.IsDynamic',
    'Admin.PSW.UsePricebookInUsedForSalesArea',

    // Add-edit product script
    'Admin.AddEditScript.InfoNoneSelectedEvent',
    'AddEditSystemEventScript.Name',
    'Admin.AddEditScript.StartDate',
    'Admin.AddEditScript.EndDate',
    'Admin.AddEditScript.Active',
    'Admin.AddEditScript.ModifiedBy',
    'Admin.AddEditScript.Events',
    'Admin.AddEditScript.AttachScriptToEvent',
    'Admin.PricebookTableEntries.ViewHistory',
    'Admin.PSW.SaveScript',
    'Admin.AddEditScript.GlobalScript',

    // Product Scripts
    'Admin.AddEditScript.CantEditGlobalScriptFromProduct',
    'Admin.PSW.Execution',
    'tbDictKey_AddRow',
    'Container.Actions',
    'Admin.PSW.Code',
    'Admin.PSW.Description',
    'Admin.PSW.Type',
    'Admin.Scripts.ModifiedDate',
    'Admin.PSW.ModifiedDate',
    'Admin.PSW.ModifiedDateFrom',
    'Admin.PSW.ModifiedDateTo',
    'Admin.PSW.Active',
    'Msg.Local',
    'xsltDateModified',
    'Admin.PSW.ScriptsTotal',
    'Admin.PSW.AddScript',
    'Msg.ScriptNameRequired',
    'Admin.Responsive.Compare',
    'Versions.SelectExactlyTwoVersionToCompare',
    'Admin.ProductScripts.QuickFilter',

    // Rules and triggers
    'Admin.PSW.AttributeTriggers',
    'Admin.PSW.AddRule',
    'Admin.PSW.Condition',
    'Admin.PSW.Action',
    'Admin.PSW.Rank',
    'Admin.PSW.ModifiedBy',
    'Admin.PSW.Ranking',
    'xmlImportExport',
    'Admin.LineItems',
    'Admin.PSW.AddEditSimpleRule',
    'Admin.Rules.QuickFilter',
    'Admin.PSW.ModifiedDateFrom',
    'Admin.PSW.ModifiedDateTo',
    'ProductMessages.Title',
    'Admin.PSW.MessageColumn',
    'Admin.PSW.AddMessage',
    'Admin.PSW.RulesTotal',
    'Admin.PSW.MessagesTotal',
    'Admin.PSW.Active',
    'PSW.ViewPrices',
    'Admin.PSW4.UserCanEnterQuantity',
    'xsltPSWInfo1',
    'Admin.PSW4.OrderWithinTheCart',
    'Admin.PSW.AttributeName',
    'Admin.PSW.NewScript',
    'Admin.PSW.GlobalScript',
    'Admin.add_edit_rule.Title',
    'Admin.PSW.AddRule',
    'Admin.PSW.SimpleRule',
    'Admin.PSW.FormulaRule',
    'Admin.PSW.AttributeTrigger',
    'Admin.PSW.Ranking',
    'xmlImportExport',
    'Admin.PSW.SaveAttribute',
    'Admin.PSW.AttributeName',
    'Admin.PSW.AttributeMustHaveAtLeastOneValue',
    'Admin.PSW.AttributeRequiresOneValueButHasMore',
    'Admin.PSW.Condition',
    'Admin.PSW.Action',
    'Admin.PSW.Rank',
    'Admin.PSW.Description',
    'Admin.PSW.Type',
    'Admin.PSW.ModifiedDate',
    'Admin.PSW.ModifiedBy',
    'Admin.PSW.ModifiedDateFrom',
    'Admin.PSW.ModifiedDateTo',
    'ProductMessages.Title',
    'Admin.PSW.MessageColumn',
    'Admin.PSW.AddMessage',
    'Admin.PSW.MessagesTotal',
    'Admin.PSW.Active',
    'PSW.ViewPrices',
    'Admin.PSW4.UserCanEnterQuantity',
    'xsltPSWInfo1',
    'Admin.PSW4.OrderWithinTheCart',
    'Admin.PSW.AttributeName',
    'Admin.PSW.AddRule',
    'Admin.PSW.SimpleRule',
    'Admin.PSW.FormulaRule',
    'Admin.PSW.AttributeTrigger',
    'Admin.PSW.Ranking',
    'AddEditTab.Title',
    'Admin.ProductConfiguratorLayout.LayoutTemplate',
    'Admin.ProductConfiguratorLayout.QuoteNumber',
    'Admin.ProductConfiguratorLayout.QuoteNumberInfo',
    'Admin.ProductConfiguratorLayout.RDLayoutTemplate',
    'Admin.PSW.Configuration',
    'Admin.PSW.Responder',
    'ProductConfiguratorLayout.DefaultTab',
    'xmlImportExport',
    'Admin.PSW.SaveAttribute',
    'Admin.PSW.AttributeName',
    'Admin.PSW.Condition',
    'Admin.PSW.Action',
    'Admin.PSW.Rank',
    'Admin.PSW.Description',
    'Admin.PSW.Type',
    'Admin.PSW.ModifiedDate',
    'Admin.PSW.ModifiedBy',
    'Admin.PSW.ModifiedDateFrom',
    'Admin.PSW.ModifiedDateTo',
    'ProductMessages.Title',
    'Admin.PSW.MessageColumn',
    'Admin.PSW.AddMessage',
    'Admin.PSW.MessagesTotal',
    'Admin.PSW.Active',
    'PSW.ViewPrices',
    'Admin.PSW4.UserCanEnterQuantity',
    'xsltPSWInfo1',
    'Admin.PSW4.OrderWithinTheCart',
    'Admin.PSW.AttributeName',
    'Admin.PSW.SimpleRules',
    'Admin.PSW.FormulaRules',
    'Admin.validationMessages.ShowInResponder',
    'Admin.validationMessages.MakeProductUncomplete',
    'Admin.validationMessages.Message',
    'Admin.validationMessages.SaveMessage',
    'Admin.validationMessages.InvalidQuoteNumber',
    'Admin.RuleDefinition',
    'Admin.PSW4.DisplayCustomControlAs',
    'xmlTabs',
    'Admin.PSW.ConfigurationPreview',
    'Admin.ProductMessages.QuickFilter',
    'Admin.FormulaRules.QuickFilter',
    'SimpleRules.CannotSelectAllAllow',

    // Trigger rules
    'Admin.ScriptingCodemirror.ScriptingMethodsList',
    'Admin.PSW.Attribute',
    'Admin.PSW.ScriptedTrigger',
    'Admin.PSW.SelectTrigger',
    'Admin.PSW.ChangeTrigger',
    'Admin.PSW.ResetTrigger',
    'Admin.PSW.TriggerDefinition',
    'Admin.Msg.SaveRule',
    'Admin.AttributeTriggers.QuickFilter',


    // Simple rules
    'Admin.add_edit_rule.LabelRuleName',
    'Admin.add_edit_rule.LabelRuleRank',
    'Admin.add_edit_rule.JSMSGRuleNameMissing',
    'Admin.PSW.IFThenRequered',
    'Admin.SimpleRules.QuickFilter',
    'SimpleRules.DisallowedValues',
    'SimpleRules.AllowedValues',
    'SimpleRules.ResetAndSelectedValues',
    'SimpleRules.SelectedValues',
    'xsltIf',
    'xsltThen',
    'xsltValues',
    'xsltAddValues',

    // Visibility Restrictions
    'VisibilityRestrictions.Title',
    'Admin.PSW.VisibilityRestrictionName',
    'Admin.PSW.AddVisibilityRestriction',
    'Admin.VisibilityRestrictions.QuickFilter',
    'Admin.RestrictionDefinition',
    'Admin.VisibilityRestrictions.DisallowAttributes',
    'Admin.VisibilityRestrictions.DisallowValues',
    'xsltAddAttributes',

    // Tabs
    'PSW.AddNewTab',
    'Admin.ProductConfiguratorLayout.TabVisibility',
    'ProductConfiguratorLayout.AlwaysDisplayed',
    'Admin.ProductConfiguratorLayout.DisplayTabsIfNotEmpty',
    'ProductConfiguratorLayout.DefineCondition',
    'TabDefnML.Name',
    'Admin.QuotePropertyEdit.Pricing',
    'Admin.ProductConfiguratorLayout.SelectTab',
    'Admin.ProductConfiguratorLayout.DisabledButtonTooltip',
    'Admin.ProductConfiguratorLayout.AddExistingTab',
    'Admin.ProductConfiguratorLayout.CreateNewTab',
    'Admin.ProductConfiguratorLayout.SaveAndCreateNewTab',
    'Admin.ProductConfiguratorLayout.CreateNewTabNameLabel',
    'Admin.Msg.Back',

    // Product Type dialog
    'Admin.AddEditProductType.ProductTypeName',
    'Admin.AddEditProductType.ProductTypeRank',

    // Product aliases
    'xmlAddProductAlias',
    'Admin.modifyproductalias.LabelAttDisplayTypeOptShow',
    'Admin.modifyproductalias.LabelAttDisplayTypeOptReadOnly',
    'Admin.modifyproductalias.LabelAttDisplayTypeOptHidden',
    'Admin.modifyproductalias.LabelSelectedValues',
    'Admin.modifyproductalias.LabelValueForFreeForm',
    'Admin.modifyproductalias.LabelAttDisplayTypeInConfigurator',
    'Admin.attribute_list.TViewColAttName',
    'Admin.ProductAlias.TitleAddNew',
    'Admin.ProductAlias.TitleEdit',
    'Admin.PSW.AttributeType',
    'Admin.ProductAlias.AditionalAliasData',
    'API.InvalidIdProvided',

    // Product versions
    'Admin.ProductVersions.VersionsFor',
    'Admin.ProductVersions.CreateNewVersion',
    'Admin.ProductVersions.VersionNumber',
    'Admin.ProductVersions.ProductNameByVersion',
    'Admin.ProductVersions.ProductVersionName',
    'Admin.ProductVersions.ProductVersionNameLabel',
    'Admin.ProductVersions.QuickFilter',
    'Admin.ProductVersions.SAPKBId',
    'Admin.ProductVersions.SAPKBVersion',
    'Admin.ProductVersions.SAPKBBuildNumber',
    'Admin.ProductVersions.SAPHashingVersion',
    'Admin.ProductVersions.SAPEffectiveDate',
    'Admin.ProductVersions.IsRootItem',
    'Admin.ProductVersions.IsRootItemInfo',
    'Msg.VCVersionActiveToday',
    'Msg.NoVersionActiveToday',

    // Sales Units of Measure
    'Admin.SalesUnitsOfMeasure.UnitsFor',
    'Admin.SalesUnitsOfMeasure.CreateNew',
    'Admin.SalesUnitsOfMeasure.Unit',
    'Admin.SalesUnitsOfMeasure.Denominator',
    'Admin.SalesUnitsOfMeasure.Numerator',
    'Admin.SalesUnitsOfMeasure.BaseUnit',
    'Admin.SalesUnitsOfMeasure.QuickFilter',

    // Attributes
    'Admin.PSW.DefineNewAttribute',
    'Admin.add_edit_attribute.AttributeExternalId',
    'Admin.add_edit_attribute.LabelAttType',
    'Admin.Attributes.AddNewAttribute',
    'Admin.add_edit_attribute.UnitOfMeasurement',
    'Admin.DataProtection.ContainsPersonallyIdentifiableInformation',
    'Admin.DataProtection.SensitiveData',
    'Admin.Attributes.AddProductsAsValues',
    'Admin.Attributes.Ranking',
    'Admin.Attributes.Value',
    'Admin.Attributes.ValueCode',
    'Admin.Attributes.Unit',
    'Admin.Attributes.ValueSystemID',
    'Admin.Attributes.ValueDescription',
    'Admin.Attributes.ValueDescription.Title',
    'Admin.Attributes.ReferenceProduct',
    'Admin.add_edit_attribute.LabelDeleteAttValue',
    'Admin.AttributeValues.QuickSearch',
    'Admin.Attributes.AddValues',
    'Admin.Attributes.AttributeValuesRanking',
    'Admin.Attributes.AttributeValuesRanking',
    'adminAttributeContainerColumnMustSelectAttributeValue',
    'Admin.AddEditAttributeContainerContent.SearchByProductMsg',
    'AttributeAdmin.ProductAttributes.LineItemNotAllowed',
    'Admin.Attributes.UsedInProducts',
    'Admin.AttributeAdmin.ProductAttributes.DuplicateAttributeNameWarning',

    //Autocomplete
    'CustomTablesDA.CustomTable',
    'Admin.AttributeAdmin.StartTypingToSearchCustomTable',
    'HierarchicalDrilldown.LabelPreselectionFilter',
    'Admin.CustomTablesDefineNew.ColumnName',
    'Favorites.Display',
    'Admin.AttributeAdmin.Placeholder',
    'Admin.AttributeAdmin.Searchable',
    'Admin.AttributeAdmin.ColumnValueCode',
    'Admin.Attribute.RankSearchable',
    'Admin.Attribute.RankDisplay',
    'Admin.AddEditAttributeContainerContent.ColumnAsProductAttributeUsed',
    'Admin.AttributeAdmin.WhereFilterHint',
    'Admin.AttributeAdmin.ShowDistinctValues',
    'Admin.AttributeAdmin.ShowDistinctHint',
    'Msg.Max',
    'Admin.AttributeAdmin.Autocomplete.MaxNumOfColumnsExceeded',
    'Admin.AddEditAttributeContainerContent.ConfirmAutocompleteSave',
    'Admin.AttributeAdmin.PlaceholderTextInfo',
    'Configurator.Attribute.AutoCompleteQuoteTableNotAvailable',
    'xmlQuoteTable',
    'Admin.AttributeAdmin.StartTypingToSearchQuoteTable',
    'Admin.AttributeAdmin.SearchMethod',
    'Admin.AttributeAdmin.SearchMethod.Contains',
    'Admin.AttributeAdmin.SearchMethod.StartsWith',

    //CodeMatching
    'Admin.CodeMatching.QuickSearch',
    'Admin.CodeMatching.CodeMatchLabel',
    'Admin.CodeMatching.AddValues',
    'Admin.AdvancedSettings.CodeMatching',

    //ProductTranslation
    'Admin.ProductTranslation.ProductInfo.Name',
    'Admin.ProductTranslation.ProductInfo.Description',
    'Admin.ProductTranslation.ProductInfo.LongDescription',
    'Admin.ProductTranslation.ProductInfo.DescriptionBuilder',
    'Admin.ProductTranslation.ProductInfo',
    'Admin.ProductTranslation.Attributes',
    'Admin.ProductTranslation.Attributes.AttributeName',
    'Admin.ProductTranslation.Attributes.Label',
    'Admin.ProductTranslation.Attributes.Hint',
    'Admin.ProductTranslation.Attributes.Description',
    'Admin.ProductTranslation.Attributes.ErrorMessage',
    'Admin.ProductTranslation.AttributeValues.Description',
    'Admin.ProductTranslation.AttributeValues.LineItemDescription',
    'Admin.ProductTranslation.Column.DefaultLanguage' ,
    'Admin.ProductTranslation.Column.Label',
    'Admin.ProductTranslation.SelectLanguage',

    //AttributeTranslation
    'Admin.AttributeTranslation.AttributeInfo',
    'Admin.AttributeTranslation.AttributeInfo.Name',
    'Admin.AttributeTranslation.RelatedValues',
    'Admin.AttributeTranslation.DisplayValue',
    'Admin.AttributeTranslation.Description',
    'Admin.AttributeTranslation.AttributeInfoTab',
    'Admin.AttributeTranslation.ContainerColumnsTab',
    'Admin.AttributeTranslation.ContainerPropertiesTab',
    'Admin.AttributeTranslation.ContainerValidationMessagesTab',
    'Admin.AttributeTranslation.ContainerColumn.Name',
    'Admin.AttributeTranslation.ContainerColumn.Header',
    'Admin.AttributeTranslation.ContainerColumn.Footer',
    'Admin.AttributeTranslation.ContainerColumn.CalculationFormula',
    'Admin.AttributeTranslation.ContainerProperty.Name',
    'Admin.AttributeTranslation.ContainerProperty.PropertyFormula',
    'Admin.AttributeTranslation.ValidationMessages.RuleName',
    'Admin.AttributeTranslation.ValidationMessages.Message',

    // Guided Selling
    'xmlGuidedSelling',
    'GuidedSelling.AddNew',
    'Admin.PSW.Step1.VisibleToEveryone',
    'Categories.Title',
    'GuidedSelling.SearchResultGrouping',
    'GuidedSelling.NumberOfPricingGroups',
    'GuidedSelling.EachPriceGroupShouldHave',
    'GuidedSelling.EqualAmountSpan',
    'GuidedSelling.EqualNumberOfProducts',
    'GuidedSelling.DescriptionHint',
    'GuidedSelling.CategoryHint',
    'GuidedSelling.AvailableAfterThisDate',
    'GuidedSelling.AvailableBeforeThisDate',
    'Admin.Scripts.IsGlobal',
    'DeploySendChanges.GuidedSelling',
    'GuidedSelling.Translation.GuidedSellingInfo',
    'Admin.ProductVersions.CreatedBy',
    'GuidedSelling.Logic',
    'GuidedSelling.LogicAND',
    'GuidedSelling.LogicOR',
    'GuidedSelling.AddNewGuidedSellingProcess',
    'GuidedSelling.SelectAttributes',
    'Admin.GuidedSelling.Total',
    'Admin.GuidedSelling.VisibilityPermissions',
    'GuidedSelling.ItemFilterCriteriaHint',
    'GuidedSelling.AddNewGuidedSellingProcess',
    'GuidedSelling.SpanAcrossRow',
    'GuidedSelling.UseAsSearchCriteria',
    'GuidedSelling.SearchInProductCategories',
    'GuidedSelling.SearchInProductCategoriesTooltip',
    'GuidedSelling.CustomLabelTooltip',
    'GuidedSelling.AttributeValuesQuickFilter',
    'GuidedSelling.AttributeValuesWithCategoriesQuickFilter',
    'Admin.PSW4.Value',
    'GuidedSelling.AttributeValuePreselected',
    'GuidedSelling.CanNotDeleteAttributeUsedInRules',
    'GuidedSelling.CanNotDeleteAttributeValuesUsedInRules',
    'GuidedSelling.CustomControlRequiresAttributeSave',

    // Attribute usage dialog
    'UserCustomFields.Title',
    'xmlQICustomFields',
    'xmlQuoteCustomFields',
    'xmlQuoteTables',
    'xmlContainers',
    'Msg.Rank',
    'xsltAttributeValue',
    'xmlAttributeDependencies',
    'xmlRules',
    'xmlAttributeName',
    'xmlRuleSource',
    'xmlRuleName',
    'xmlRuleType',
    'xmlProductFields',
    'xmlProductAttributeFields',
    'xmlProductAttrbuteValueFields',
    'xmlTriggers',
    'xmlTriggerType',
    'xmlAttributeTrigger',

    //export dialog
    'Admin.BulkExportProductTranslation.ExportScheduled',
    'Admin.BulkExportProduct.ExportScheduled',

    // Categories
    'CategoryList.AddNewCategory',
    'Admin.CategoriesDataTable.QuickSearch',
    'Admin.CategoryList.LabelCategoryName',
    'Admin.CategoryList.LabelCategoryDescription',
    'Admin.Category.lblSystemId',
    'Admin.CategoryList.LabelCategoryActive',
    'CategoryModifications.ParentName',
    'CategoryModifications.DefaultCatalogueViewLabel',
    'CategoryModifications.RedirectUrl',
    'AddCategory.AdditionalImage1',
    'AddCategory.AdditionalImage2',
    'CategoryModifications.MobileOnlyImage',
    'CategoryModifications.VisibilityOfProducts',
    'CategoryModifications.VisibilityOfSubCategories',
    'CategoryModifications.ApplyToProducts',
    'CategoryModifications.ApplyToSubCategories',
    'CategoryModifications.DefaultView.Tabular',
    'CategoryModifications.DefaultView.List',
    'CategoryModifications.DefaultView.Custom',
    'CategoryModifications.CategoryVisibilityPermissions',
    'CategoryModifications.CategoryVisibilityPermissionsPropagated',
    'CategoryModifications.CategoryAvailableAfter',
    'CategoryModifications.CategoryAvailableBefore',
    'CategoryModifications.DefaultCatalogView',
    'CategoryModifications.AddSubCategoryButton',
    'Admin.ProductsModifications.SubCategories',
    'Admin.Msg.SetRank',
    'CategoryModifications.CategoryVisibilityOfProductsInfoMessage',
    'CategoryModifications.RemoveSubCategoryWarning',
    'CategoryModifications.RemoveSubCategoryMessage',

    // CategoryTranslation
    'Admin.CategoryTranslation.CategoryInfo',
    'Admin.CategoryTranslation.CategoryInfo.Name',
    'Admin.CategoryTranslation.CategoryInfo.Description',

    // Sales Area
    
    'SalesArea.Assigments.SalesOrganization',
    'SalesArea.Assigments.DistributionChannel',
    'Product.SalesArea.SalesUnit',
    'Product.SalesArea.itemCategoryGroup',
    'Product.SalesArea.distributionChainSpecificStatusValidFrom',
    'Product.SalesArea.PricingReferenceMaterial',
    'Product.SalesArea.ProductHierarchy',
    'Product.SalesArea.MaterialPriceGroup',
    'Product.SalesArea.SalesText',
    'Product.SalesArea.DistributionChains',
    'Product.SalesArea.isDeleted',
    'Product.SalesArea.DistributionChain.Tab',
    'Product.SalesArea.DCChainStatus',
    'SalesAreaList.QuickSearch',
    'xmlSalesOrganizations',
    'SalesArea.Assigments.DistributionChannel',

    // Product Custom Fields
    'Admin.ProductCustomField.isSalesAreaRelevant',
    'Admin.ProductCustomFields.QuickSearch',
    'xmlProductCustomFields',
    'Admin.CustomFields.ColumnName.PersonalData',
    'Admin.DataProtection.SensitiveData',
    'Admin.ProductCustomField.isSalesAreaRelevant',
    'Admin.UserCustomField.Type'
];
